import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Button from 'material-ui/Button';
import Help from 'material-ui-icons/HelpOutline';
import { withStyles, createMuiTheme } from '@material-ui/core/styles';

import 'react-tippy/dist/tippy.css';
import { Tooltip } from 'react-tippy';

import Header from './Header';

const styles = theme => ({
  toolTipButtonStyle: {
    position: 'fixed',
    bottom: theme.spacing.unit * 2,
    right: theme.spacing.unit * 3
  },
  buttonStyle : {
    background: '#002053 !important',
    color: 'white !important'
  },
  toolTipStyle: {
    margin: '5%',
    textAlign: 'justify',
    width:'87.1%'
  }
});

const theme = createMuiTheme({
  palette: {
  },
  typography: {
    useNextVariants: true,
  },
});


function Layout(props) {
    return (
        <MuiThemeProvider theme={theme}>
            <div className={props.className}>
              {
                props.showHeader !== false &&
                <Header
                  showMenu={props.showMenu}
                  menuTitle={props.menuTitle}
                  leftTitle={props.leftTitle}
                  rightTitle={props.rightTitle}
                />
              }
                { props.children }
              {
                props.toolTip &&
                <Tooltip
                    html={(<p className={props.classes.toolTipStyle}> {props.toolTip} </p>)}
                    position="top"
                    trigger="mouseenter"
                    distance={10}
                    className={props.classes.toolTipButtonStyle}
                >
                  <Button variant="fab" color="inherit" className={props.classes.buttonStyle} >
                    <Help />
                  </Button>
                </Tooltip>
              }
            </div>
        </MuiThemeProvider>
    );
}

export default withStyles(styles, { withTheme: true })(Layout);


// WEBPACK FOOTER //
// ./src/components/Layout.js